import { Box, Stack, Typography } from "@mui/material";
import React from "react";
import { Theme } from "../../../Styles/GlobalTheme";

interface EmptyDataComponentProps {
  message: string;
  splitLongMessages?: boolean;
  splitLength?: number;
}

export const EmptyDataComponent: React.FC<EmptyDataComponentProps> = ({
  message,
  splitLongMessages = true,
  splitLength = 68,
}) => {
  const shouldSplit = splitLongMessages && message.length >= splitLength;

  if (shouldSplit) {
    const firstPart = message.substring(0, splitLength);
    const secondPart = message.substring(splitLength);

    return (
      <Box my={5} textAlign="center" data-testid="empty-data-message">
        <Typography
          component="p"
          fontWeight={600}
          fontSize={{ md: "20px", xs: "16px" }}
          color={Theme.palette.customcolor.customText}>
          {firstPart}
        </Typography>
        <Typography
          component="p"
          fontWeight={600}
          fontSize={{ md: "20px", xs: "16px" }}
          color={Theme.palette.customcolor.customText}>
          {secondPart}
        </Typography>
      </Box>
    );
  }

  return (
    <>
      <Stack my={5} direction={"row"} justifyContent={"center"}>
        <Typography
          component={"p"}
          textAlign={"center"}
          data-testid="empty-data-message"
          fontSize={{ sm: "20px", xs: "16px" }}
          fontWeight={600}
          color={Theme.palette.customcolor.customText}>
          {message}
        </Typography>
      </Stack>
    </>
  );
};
